module.exports = __webpack_public_path__ + "img/search.dc9b1331.svg";